import React from 'react';
import PropTypes from 'prop-types';
import shuffle from 'lodash/shuffle';
import Color from 'color';
import Aspect from '../Aspect';
import Style from '../Style';

import img01 from '../../assets/instagram/Storytape-1.jpg';
import img02 from '../../assets/instagram/Storytape-2.jpg';
import img03 from '../../assets/instagram/Storytape-3.jpg';
import img04 from '../../assets/instagram/Storytape-4.jpg';
import img05 from '../../assets/instagram/Storytape-5.jpg';
import img06 from '../../assets/instagram/Storytape-6.jpg';
import img07 from '../../assets/instagram/Storytape-7.jpg';
import img08 from '../../assets/instagram/Storytape-8.jpg';
import img09 from '../../assets/instagram/Storytape-9.jpg';
import img10 from '../../assets/instagram/Storytape-10.jpg';
import img11 from '../../assets/instagram/Storytape-11.jpg';
import img12 from '../../assets/instagram/Storytape-12.jpg';

const images = [
  img01,
  img02,
  img03,
  img04,
  img05,
  img06,
  img07,
  img08,
  img09,
  img10,
  img11,
  img12,
];

class InstagramGrid extends React.PureComponent {
  static propTypes = {
    overlayColor: PropTypes.string,
  };
  static defaultProps = {
    overlayColor: 'transparent',
  };

  constructor(props) {
    super(props);

    this.state = {
      images: shuffle(images),
    };
  }

  render() {
    return (
      <div
        style={{
          margin: '-2%',
          width: '100%',
          display: 'flex',
          flexWrap: 'wrap',
        }}
      >
        {this.state.images.map(url => {
          return (
            <div
              key={url}
              style={{ width: '26%', flex: '1 1 26%', margin: '2%' }}
            >
              <Aspect>
                <div
                  style={{
                    backgroundImage: `url(${url})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    width: '100%',
                    height: '100%',
                  }}
                >
                  <div
                    style={{
                      width: '100%',
                      height: '100%',
                      border: `0.15rem solid ${Color(Style.Colors.white)
                        .alpha(0.5)
                        .string()}`,
                    }}
                  />
                </div>
              </Aspect>
            </div>
          );
        })}
      </div>
    );
  }
}

export default InstagramGrid;

function Row(images) {}



// WEBPACK FOOTER //
// ./src/components/InstagramGrid/InstagramGrid.js